// Photo guidance shown right below every "Texto listo para publicar" card.
// Keyed by businessType. Missing giros fall back to null (nothing rendered).

export const FOTO_GUIA = {
  taqueria:
    "📸 Foto desde arriba, luz natural, fondo de madera o papel.",
  polleria:
    "📸 Foto desde arriba del pollo recién salido, vapor visible, luz directa.",
  bar:
    "📸 Foto horizontal, luz cálida, incluye la bebida y el ambiente.",
  ropa:
    "📸 Foto de la prenda puesta en persona, luz natural de ventana, fondo neutro.",
  gym:
    "📸 Foto o video de 15 seg del movimiento, buena iluminación, ropa limpia.",
  puesto:
    "📸 Foto en mano o en plato, luz de mediodía, fondo simple.",
  abarrotes:
    "📸 Foto del producto en el mostrador, precio visible, luz interior.",
};
